export default __webpack_public_path__ + "static/media/GoodMannersOnThePlayground_10.0a77643e.png";